<template>
  <div class="layout-box">
    <LayoutHeader headtitle="云直播"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a @click="$router.go(-1)">首页</a> > 云直播</div>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in explistdata" :key="index">
          <a :href='item.url' target="_blank"><img :src='item.img'/></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'CloudLive',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      explistdata:[
        {img:'https://forum.ccf.com.cn/fiber/img/live/1.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f066ab6e4b09c1412e386ea?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/2.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f0d16b5e4b04349896b7c1a?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/3.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f110108e4b0ee0b88730713?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/4.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f1104e7e4b04349896c7b1b?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/5.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f114021e4b0ee0b88731fd8?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/6.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f114021e4b0ee0b88731fd8?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/7.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f114021e4b0ee0b88731fd8?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/8.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f1a3fdce4b0a1003caeda14?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/9.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f1a875ce4b0a1003caef959?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/10.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f1a8bb6e4b0a1003caefbd5?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/11.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f1a9240e4b0df48afbd6df1?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/12.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_5f1a7605e4b0df48afbd5da3?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/13.jpg',url:'https://app9sksmalo3870.h5.xiaoeknow.com/v2/course/alive/l_60063f39e4b0ab9a2549b860?app_id=app9sksmAlo3870&alive_mode=0&pro_id=&type=2&is_redirect=1'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/14.jpg',url:'https://live.vhall.com/280513723?shareId=u-37660529-3'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/15.jpg',url:'https://live.vhall.com/606883507?shareId=u-37660529-3'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/16.jpg',url:'https://live.vhall.com/290348496'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/18.jpg',url:'https://live.vhall.com/154285402'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/19.jpg',url:'https://live.vhall.com/526312562'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/20.jpg',url:'https://live.vhall.com/256871218?shareId=u-37660529-3'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/21.jpg',url:'https://live.vhall.com/895650849?shareId=u-37660529-3'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/22.jpg',url:'https://live.vhall.com/738076610?shareId=u-37660529-3'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/23.jpg',url:'https://live.vhall.com/948925856?shareId=u-37660529-3'},
        {img:'https://forum.ccf.com.cn/fiber/img/live/24.jpg',url:'https://live.vhall.com/838026212?shareId=u-37660529-3'}
      ]
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}


.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-list{
  padding: 30px 0 0 18px;
}

.experts-list li{
  width: 311px;
  height: 220px;
  padding: 10px;
  margin: 0 12px 25px 12px;
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
  display: flex;
  justify-content: space-between;
}

.experts-list li:hover{
  background: #2095EF;
  border: 2px solid #2095EF;
  padding: 8px;
}

.experts-list li img{
  width: 311px;
}


</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-cloudlive-list.vue